import { Project } from "@brg/api";
import { useMemo, useState } from "react";
import useProjectChapters from "./useProjectChapters";

const useChapterPosts = (project: Project<'Global'>) => {
    const chapters = useProjectChapters(project);

    const posts = useMemo(() => chapters.reduce((acc, chapter, index) => {
        return [...acc,
            {
                id: index,
                style: 'colored',
                text: chapter.title,
                color: project.additionalInfo?.chapterColor,
                specBlock: null,
            },
            {
                id: chapter.projectId + index,
                style: 'projects',
                projectIds: [chapter.projectId],
                specBlock: null,
            }];
        }, [])
    , [chapters]);

    return posts;
}

export default useChapterPosts;import { Project } from "@brg/api";
import { useMemo, useState } from "react";
import useProjectChapters from "./useProjectChapters";

const useChapterPosts = (project: Project<'Global'>) => {
    const chapters = useProjectChapters(project);

    const posts = useMemo(() => chapters.reduce((acc, chapter, index) => {
        return [...acc,
            {
                id: index,
                style: 'colored',
                text: chapter.title,
                color: project.additionalInfo?.chapterColor,
                specBlock: null,
            },
            {
                id: chapter.projectId + index,
                style: 'projects',
                projectIds: [chapter.projectId],
                specBlock: null,
            }];
        }, [])
    , [chapters]);

    return posts;
}

export default useChapterPosts;